module.exports = __webpack_public_path__ + "img/tertiary_6x1_z18.4d0fb3b7.svg";